import React, { useEffect } from "react"

import Paper from "@mui/material/Paper"

import { useHookstate } from "@hookstate/core"

import globalState from "../../features/global-state"
import { saveLead } from "../../features/pages/lead"
import { useGlobalSnackBar } from "@refere/ui-utils/ui/components/AppRoot"

const Lead = () => {
    const leadState = useHookstate(globalState.leadState)

    const { showAlertSnackBar } = useGlobalSnackBar();

    const handleProposalConfirmed = async (event: any) => {
        const strUrl = leadState.url.get();
        if (!strUrl) return;

        const url = new URL(strUrl);

        // Verificar a origem da mensagem para garantir segurança
        if (event.origin !== url.origin)
        {
            const errorMessage = `Origem da mensagem não autorizada: ${event.origin}. A Proposta NÃO foi efetivada no Modular/Sigas.`
            showAlertSnackBar(errorMessage, "error");
            throw errorMessage;
        }
        else
        {
            const hasProposta = leadState.hasNumeroProposta.get()

            // Se a simulação já tiver proposta não salva no banco nem faz efetivação
            // Isso garante que não salve proposta de outra simulação nela,
            // nem tente efetivar no sigas uma proposta que já tenha sido efetivada
            if (hasProposta)
                return;

            const data = event.data;

            const valor = Number.parseFloat(data.contributionValue);
            const parcelas = Number.parseInt(data.installment);

            await saveLead(data.proposalNumber, valor, parcelas, data.frequency)
        }

    }

    useEffect(() => {
        window.addEventListener("message", handleProposalConfirmed);

        return () => {
            window.removeEventListener('message', handleProposalConfirmed);
        };

    }, []);

    useEffect(() => {
        if (leadState.mensagemDeErro.get())
            showAlertSnackBar(leadState.mensagemDeErro.get(), "info");

    }, [ leadState ])


    return(
        leadState.get() &&
        <>
            <Paper
                sx={{
                    mb: 1
                }}
            >
                <iframe
                    src={leadState.url.get()}
                    width="100%"
                    height="650"
                    style={{ border: "none" }}
                ></iframe>
            </Paper>
        </>
    )
}

export default Lead